import * as React from 'react'

// ----- PrintMode

export const useSGPrintMode = () => {
  React.useEffect(() => {
    const handleBeforePrint = () => {
      const allDetails = document.querySelectorAll('details')
      allDetails.forEach((details) => {
        details.setAttribute('open', '')
      })
    }

    const handleAfterPrint = () => {
      const allDetails = document.querySelectorAll('details')
      allDetails.forEach((details) => {
        details.removeAttribute('open')
      })
    }

    window.addEventListener('beforeprint', handleBeforePrint)
    window.addEventListener('afterprint', handleAfterPrint)

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint)
      window.removeEventListener('afterprint', handleAfterPrint)
    }
  }, [])
}
